"use client";

import Link from "next/link";
import { Category } from "@/types/category";

type Props = {
    categories: Category[];
    currentCategory: Category;
    pathname: string;
    activeSlugPath: string[];
};

export default function SubMenu({
                                    categories,
                                    currentCategory,
                                    pathname,
                                    activeSlugPath,
                                }: Props) {

    const currentId = Number(currentCategory.id);

    const subCategories = categories.filter(
        (cat) => Number(cat.parent_id) === currentId
    );

    if (!subCategories.length) {
        return null;
    }

    return (
        <div className="flex flex-col gap-4">
            {subCategories.map((cat) => {
                const children = categories.filter(
                    (item) => Number(item.parent_id) === Number(cat.id)
                );

                const isCatActive = activeSlugPath.includes(cat.slug);

                return (
                    <div key={cat.id}>
                        <Link
                            href={`${pathname}/${cat.slug}`}
                            prefetch={true}
                            className={`flex hover:text-amber-600 ${
                                cat.style === "label"
                                    ? "text-xl font-bold text-blue-700"
                                    : `text-lg font-medium ${
                                        isCatActive
                                            ? "text-amber-600 font-bold"
                                            : "text-gray-800"
                                    }`
                            }`}
                        >
                            {cat.style === "label" && (
                                <span className="w-1 h-5 bg-blue-600 rounded-lg mt-1 ml-2"></span>
                            )}

                            {cat.title}
                        </Link>
                        {cat.style === "label" && children.length > 0 && (
                            <div className="mt-2 mr-4 flex flex-col gap-2">
                                {children.map((child) => {
                                    const isChildActive = activeSlugPath.includes(child.slug);
                                    return (
                                        <Link
                                            key={child.id}
                                            href={`${pathname}/${cat.slug}/${child.slug}`}
                                            className={`text-lg hover:text-blue-600 ${
                                                isChildActive
                                                    ? "text-blue-600 font-bold"
                                                    : "text-gray-600"
                                            }`}
                                            prefetch={true}
                                        >
                                            {child.title}
                                        </Link>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
